import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 0) {
        snackBar.open('Network error — server may be unreachable', 'Dismiss', { duration: 5000 });
      } else if (error.status >= 500) {
        snackBar.open(`Server error (${error.status})`, 'Dismiss', { duration: 5000 });
      }
      return throwError(() => error);
    })
  );
};
